import { render, staticRenderFns } from "./gxjyheader.vue?vue&type=template&id=1630f5d0&scoped=true&"
import script from "./gxjyheader.vue?vue&type=script&lang=js&"
export * from "./gxjyheader.vue?vue&type=script&lang=js&"
import style0 from "./gxjyheader.vue?vue&type=style&index=0&id=1630f5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630f5d0",
  null
  
)

export default component.exports